import { TableBody } from "react-aria-components";

import { EmptyTable } from "@/ui2/molecules/(table)/EmptyTable";
import { Table2 } from "@/ui2/atoms/(table)/Table";

import type { AdaptedCsmRow } from "../helpers/adapters";

import { CsmTableHeader } from "./components/CsmTableHeader";
import { CsmTableRow } from "./components/CsmTableRow";
import { CsmTableSkeleton } from "./components/CsmTableSkeleton";

type CsmTableProps = {
  isLoading: boolean;
  rows: AdaptedCsmRow[];
};

export function CsmTable({ isLoading, rows }: CsmTableProps) {
  return (
    <Table2 aria-label="Customer success managers">
      <CsmTableHeader />

      {isLoading ? (
        <CsmTableSkeleton />
      ) : (
        <TableBody
          items={rows}
          renderEmptyState={() => <EmptyTable message="No customer success managers found" />}
        >
          {(row) => <CsmTableRow row={row} />}
        </TableBody>
      )}
    </Table2>
  );
}
